import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const AffectedItemsOrderEntryDomesticStepConfig: StepConfig = {
    type: FormType.AFFECTED_ITEMS_ORDER_ENTRY_DOMESTIC
};
